// extracted by mini-css-extract-plugin
export default {"wrapper":"HolidayOrPolicyView_wrapper__KrWvJ"};